import { useEffect } from "react";

const SITE_URL = "https://www.ipo-labs.com";
const DEFAULT_IMAGE = `${SITE_URL}/ipolabs-logo.png`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Dependency-free per-page SEO: title, meta description, canonical, Open Graph +
// Twitter, and optional page-level JSON-LD (e.g. Article + BreadcrumbList).
// Site-wide Organization/WebSite JSON-LD lives statically in public/index.html.
export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd = null, keywords = null }) => {
  const url = `${SITE_URL}${path}`;
  const jsonLdStr = jsonLd ? JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : "";
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setLink("canonical", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "IPOLabs");
    if (title) setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    if (title) setMeta("name", "twitter:title", title);
    if (description) setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    // Manage page-level JSON-LD (tagged so the static index.html blocks are untouched)
    document.head.querySelectorAll('script[data-seo-jsonld="1"]').forEach((n) => n.remove());
    if (jsonLdStr) {
      JSON.parse(jsonLdStr).forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-jsonld", "1");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
    return () => {
      document.head.querySelectorAll('script[data-seo-jsonld="1"]').forEach((n) => n.remove());
    };
  }, [title, description, url, image, jsonLdStr, keywords]);
  return null;
};

export default Seo;
